// Dependencies
// -----------------------------------------------
import React from 'react';
import { connect } from 'react-redux';
import { DateRangePicker } from 'react-dates';
import get from 'lodash/get';
import ReactI18n from 'react-i18n';
import { Box, InputDateRange, Label } from '@directsoftware/ui-kit-web-admin';

// -----------------------------------------------
// COMPONENT->DEFAULT-RANGE-PICKER ---------------
// -----------------------------------------------
class DefaultRangePicker extends React.Component {
  // Constructor
  // ---------------------------------------------
  constructor(props) {
    super(props);

    this.state = {
      focusedInput: null,
      startDate: props.initialStartDate,
      endDate: props.initialEndDate
    };
  }

  // Component Will Receive Props
  // ---------------------------------------------
  componentWillReceiveProps(nextProps) {
    const { startDateOverride, endDateOverride } = nextProps;

    if (!startDateOverride || !endDateOverride) return null;

    this.setState({
      startDate: startDateOverride,
      endDate: endDateOverride
    });
  }

  // On Dates Change
  // ---------------------------------------------
  onDatesChange = ({ startDate, endDate }) => {
    this.setState({ startDate, endDate });
  };

  // On Focus Change
  // ---------------------------------------------
  onFocusChange = focusedInput => {
    this.setState({ focusedInput }, () => {
      if (typeof this.props.onFocusChange === 'function') {
        this.props.onFocusChange(focusedInput);
      }
      if (
        this.state.startDate &&
        this.state.endDate &&
        !this.state.focusedInput
      ) {
        if (typeof this.props.onDatesSet === 'function') {
          this.props.onDatesSet({
            startDate: this.state.startDate,
            endDate: this.state.endDate
          });
        }
      }
    });
  };

  // On Date Unset
  // ---------------------------------------------
  onDatesUnset = () => {
    const data = { startDate: null, endDate: null };

    this.setState(data, () => {
      if (typeof this.props.onDatesSet === 'function') {
        this.props.onDatesSet(data);
      }
    });
  };

  // Component Did Mount
  // ---------------------------------------------
  render() {
    const translate = ReactI18n.getIntlMessage;
    const isRvFleet = this.props.organizationType === 'rv_fleet';
    const translationBase = isRvFleet ? 'cx.global.rv_fleet' : 'cx.global';
    const startPlaceholder =
      this.props.startPlaceHolder || translate(`${translationBase}.check_in`);
    const endPlaceholder =
      this.props.endPlaceHolder || translate(`${translationBase}.check_out`);

    if (!this.state.startDate && this.props.initialStartDate) {
      this.state.startDate = this.props.initialStartDate;
      this.state.endDate = this.props.initialEndDate;
    }

    return this.props.useDesignKit ? (
      <>
        {this.props.label && <Label>{this.props.label}</Label>}
        <Box setPositionRelative>
          <InputDateRange
            startDatePlaceholderText={this.props.startPlaceholder}
            endDatePlaceholderText={this.props.endPlaceholder}
            onDatesChange={this.onDatesChange}
            onFocusChange={this.onFocusChange}
            focusedInput={this.state.focusedInput}
            numberOfMonths={this.props.numberOfMonths}
            startDate={this.state.startDate}
            startDateId="default_range_picker_start_id"
            endDate={this.state.endDate}
            endDateId="default_range_picker_end_id"
            minimumNights={
              Number.isInteger(this.props.minimumNightsOverride)
                ? this.props.minimumNightsOverride
                : this.props.minimumNights
            }
            isOutsideRange={this.props.isOutsideRange}
            isDayBlocked={this.props.isDayBlocked}
            renderCalendarDay={this.props.renderCalendarDay}
            hideKeyboardShortcutsPanel
            disabled={this.props.disabled}
            displayFormat={
              this.props.displayFormat ||
              get(this, 'context.dateFormat', () => {})()
            }
            readOnly={this.props.readOnly}
          />
        </Box>
      </>
    ) : (
      <figure style={this.props.styles} className={this.props.containerClass}>
        {this.props.label && (
          <label style={this.props.labelStyles}>{this.props.label}</label>
        )}
        <div className="datepicker">
          <DateRangePicker
            startDatePlaceholderText={startPlaceholder}
            endDatePlaceholderText={endPlaceholder}
            onDatesChange={this.onDatesChange}
            onFocusChange={this.onFocusChange}
            focusedInput={this.state.focusedInput}
            numberOfMonths={this.props.numberOfMonths}
            startDate={this.state.startDate}
            startDateId="default_range_picker_start_id"
            endDate={this.state.endDate}
            endDateId="default_range_picker_end_id"
            minimumNights={
              Number.isInteger(this.props.minimumNightsOverride)
                ? this.props.minimumNightsOverride
                : this.props.minimumNights
            }
            isOutsideRange={this.props.isOutsideRange}
            isDayBlocked={this.props.isDayBlocked}
            renderCalendarDay={this.props.renderCalendarDay}
            hideKeyboardShortcutsPanel
            disabled={this.props.disabled}
            displayFormat={
              this.props.displayFormat ||
              get(this, 'context.dateFormat', () => {})()
            }
            readOnly={this.props.readOnly}
          />
          {typeof this.props.renderUnsetLink === 'function'
            ? this.props.renderUnsetLink(this.onDatesUnset)
            : null}
        </div>
      </figure>
    );
  }
}

// Default Props
// -----------------------------------------------
DefaultRangePicker.defaultProps = {
  onDatesSet: () => false,
  isOutsideRange: () => false,
  isDayBlocked: () => false,
  startPlaceholder: 'Start',
  endPlaceholder: 'End',
  numberOfMonths: 1,
  minimumNights: 1,
  renderUnsetLink: func => null,
  readOnly: false
};

// Map State to Props
// -----------------------------------------------
function mapStateToProps(state) {
  return {
    organizationType: state.brand
      ? state.brand.organization?.organization_type
      : null
  };
}

export default connect(mapStateToProps)(DefaultRangePicker);
